<template>
  <div class="ui vue search" :class="variant" tabindex="-1">
    <div class="ui icon input" :class="inputClass">
      <input ref="prompt" id="city-input-field" class="prompt" type="text" autocomplete="off"
             :value="text" :placeholder="placeholder"
             @input="onInputPrompt"
             @focusout.self="onFocusoutPrompt"
             style="padding-right: 5em !important;" />
      <img class="powered-by-google" style="margin-left: -4.5em;" :src="googleImageSrc" alt="Powered by Google" />
    </div>
    <div v-if="results" ref="results" class="results" :class="resultsClass" :style="resultsStyle">
      <div v-if="!results.length" class="message empty">
        <div class="header">{{ $t('components.geo-search.no-results.header') }}</div>
        <div class="description">{{ $t('components.geo-search.no-results.description') }}</div>
      </div>
      <a class="result" v-for="(result, index) in results" :key="index"
         @click.prevent.stop="onSelectResult(result)">
        <div class="content">
          <div class="title">{{ result.text }}</div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>

import { v4 as uuidv4 } from 'uuid';
import Configuration from '../Configuration';

const publicBaseUrl = Configuration.get('public-base-url', '');

export default {
  props: {
    value: Object,
    variant: String,
    placeholder: String,
    language: String,
    layers: {
      type: String,
      default: 'coarse'
    },
    sources: {
      type: String,
      default: 'gn'
    },
  },
  data() {
    return {
      loading: false,     // An autocomplete load is in progress
      search: null,       // Input value
      results: null,      // Autocompletion results
      timeout: null,      // The setTimeout() handle for autocomplete delay
      sessionToken: null, // The Google Maps Places API billing session token
      coordinates: {      // The coordinates of selected location
        latitude: null,
        longitude: null
      }
    }
  },
  created() {
    this.console = console
    this.api = () => window.locationApiClient
  },
  methods: {
    onFocusoutPrompt(event) { // Input element unfocused
      if (event.relatedTarget !== this.$el) {
        this.results = null
        this.search = null

        this.$emit('focusout') // Emit event on self
      }
    },

    onInputPrompt() { // On input to input element
      // Cancel ongoing timeout
      if (this.timeout !== null) {
        window.clearTimeout(this.timeout)
      }

      this.search = this.$refs.prompt.value

      if (this.search === '') { // Empty input
        this.loading = false
        this.results = null

        this.$emit('input', {city: null, country: null})

        return
      }

      this.loading = true

      // Start timeout after which autocomplete is requested
      this.timeout = window.setTimeout(async () => {
        try {
          // Generate UUID for Google Maps Places API billing session
          if (!this.sessionToken) {
            this.sessionToken = uuidv4();
          }

          const language = this.$i18n.locale;
          this.results = await this.api().getSuggestions(this.search, language, this.sessionToken);
        } catch (err) {
          this.console.error(err);
          this.results = [];
        } finally {
          this.loading = false;
        }
      }, 1000)
    },

    async onSelectResult(result) { // When selecting an autocomplete suggestion
      try {
        // For persistence, always use the English name, because names are not localized again
        // @TODO: Localize again on display, maybe using a place ID or backend cache?
        const language = "en"; // this.$i18n.locale;
        
        const sessionToken = this.sessionToken;
        this.sessionToken = null;

        const { address, coordinates } = await this.api().getPlace(result.placeId, language, sessionToken)
        this.coordinates = coordinates;

        this.$emit('input', { ...address });

        this.results = null;
        this.search = null;

        this.$refs.prompt.focus();
      } catch(err) {
        this.console.error(err);
        // TODO: What now?
      }
    }
  },
  computed: {
    inputClass() {
      return this.loading ? {
        loading: true
      } : {}
    },
    resultsStyle() {
      return this.results !== null ? {
        display: 'block !important'
      } : {}
    },
    resultsClass() {
      return this.results !== null ? {
        visible: true,
        transition: true
      } : {}
    },
    text() {
      if (this.search !== null) {
        return this.search
      } else if (this.value !== null && this.value.city !== null) {
        return `${this.value.city}` + (this.value.country !== null ? `, ${this.value.country}` : '');
      }

      return ''
    },
    googleImageSrc() {
      return `${publicBaseUrl}/assets/google_on_white.png`;
    },
  }
}
</script>
